// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AlertWarning: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
            <path
                fill="currentColor"
                d="M30.3312618,29.9999573 C31.6113045,29.9999573 32.4157816,28.5939509 31.7748787,27.4691596 L23.443649,12.8432332 C22.8035598,11.7199525 21.1975556,11.7178925 20.5563474,12.8432332 L12.2248804,27.4691596 C11.585232,28.591788 12.3860131,29.9999573 13.6685311,29.9999573 L30.3312618,29.9999573 Z M22.8428258,23.812472 L21.1571706,23.812472 C20.9358843,23.812472 20.7531858,23.6373092 20.7411483,23.4136006 L20.48358,18.632362 C20.4705592,18.3906977 20.660548,18.1874854 20.8995684,18.1874854 L23.1003941,18.1874854 C23.3394145,18.1874854 23.5294373,18.3906977 23.5164164,18.632362 L23.2588481,23.4136006 C23.2468106,23.6373092 23.0641121,23.812472 22.8428258,23.812472 Z M21.9999982,27.6796503 C21.1178708,27.6796503 20.4027762,26.9556187 20.4027762,26.0624666 C20.4027762,25.1693146 21.1178708,24.445283 21.9999982,24.445283 C22.8821256,24.445283 23.5972202,25.1693146 23.5972202,26.0624666 C23.5972202,26.9556187 22.8821256,27.6796503 21.9999982,27.6796503 Z"
                transform="translate(-12 -12)"
            />
        </svg>
    );
};

export default React.memo(AlertWarning);
